import isString from 'lodash/isString';

import { GET_SERVICE_PAGE_REGEX } from '../constants/routes';

/**
 *
 * @param {string} href
 * @param {string} bookingUrl
 * @returns {boolean}
 */
const checkServicePage = (href, bookingUrl) => {
  if (!isString(href)) return false;

  return GET_SERVICE_PAGE_REGEX(bookingUrl).test(href);
};

export default checkServicePage;
